import React, {useState} from 'react'
import {
    Dropdown,
    Header,
    Grid,
    Message,
    Form,
    Progress
} from "semantic-ui-react";
import RecordDataWrapper from "../components/RecordDataWrapper";

function Translate(
    {
        handleAssignmentChange,
        assignmentOptions,
        languageOptions,
        flashCards,
        handleLanguageChange,
        samoanDefault,
        assignmentNum,
        startQuiz,
        handleStartQuiz,
        handleStopQuiz,
        nextCardTimer,
        handleSlider,
        translationFlashCard,
        loading,
        scrollMenu,
        progress,
        progressText,
        assignmentChosen,
        classLevel,
        updateAssignmentNames
    }
) {

    return (
        <>
            <br/>
            <Grid className='center aligned'>
                <Grid.Row>
                    <Header as='h1'>{translationFlashCard ? "Translation" : "Dialog"} Flash Cards</Header>
                </Grid.Row>
                <Grid.Row>
                    <Message color='teal'>
                        <p style={{color: 'black'}}>
                            Click on a flash card to flip it over. Click an ear button to hear the
                            pronunciation.
                            <br/>
                            Use the dropdown below to choose an assignment to work on.
                        </p>
                    </Message>
                </Grid.Row>

            </Grid>
            {
                loading ?
                    <Grid centered={true}>
                        <Grid.Row>

                            <Progress style={{width: 400}} percent={progress} progress
                                      indicating>{progressText}</Progress>
                        </Grid.Row>
                    </Grid>


                    :
                    <Grid centered={true}>
                        <Grid.Row style={{marginBottom: 10}}>
                            <Dropdown
                                onChange={handleAssignmentChange}
                                options={assignmentOptions}
                                placeholder='Choose an assignment'
                                selection
                                value={assignmentNum}
                            />
                            {translationFlashCard && assignmentChosen ?
                                <Dropdown
                                    onChange={handleLanguageChange}
                                    options={languageOptions}
                                    placeholder='Samoan'
                                    selection
                                    value={samoanDefault}
                                    style={{marginLeft: 5}}

                                />
                                :
                                null
                            }

                        </Grid.Row>
                    </Grid>
            }
            {
                assignmentChosen ?
                    <>
                        {startQuiz ?
                            <Grid className='center aligned'>
                                {flashCards}
                            </Grid>
                            :
                            scrollMenu
                        }
                        <Grid className='center aligned' style={{marginTop: 10}}>
                            <Grid.Row>
                                <Form.Input
                                    label={`Difficulty Level: (${nextCardTimer / 1000} second delay) `}
                                    min={5000}
                                    max={10000}
                                    name='timer'
                                    onChange={handleSlider}
                                    step={100}
                                    type='range'
                                    value={nextCardTimer}
                                />

                            </Grid.Row>
                            {
                                translationFlashCard ?
                                    <RecordDataWrapper
                                        classLevel={classLevel}
                                        page='translationFCData'
                                        startQuiz={startQuiz}
                                        handleStartQuiz={handleStartQuiz}
                                        assignmentNum={assignmentNum}
                                        handleStopQuiz={handleStopQuiz}
                                        updateAssignmentNames={updateAssignmentNames}
                                    />
                                    :
                                    <RecordDataWrapper
                                        classLevel={classLevel}
                                        page='dialogFCData'
                                        startQuiz={startQuiz}
                                        handleStartQuiz={handleStartQuiz}
                                        assignmentNum={assignmentNum}
                                        handleStopQuiz={handleStopQuiz}
                                        updateAssignmentNames={updateAssignmentNames}
                                    />
                            }


                        </Grid>
                        <br/><br/>
                    </>
                    :
                    null
            }

        </>
    )
}


export default Translate
